<template>
    <div class="tncPageContainer">
        <div class="wrapper"> 
            <img class="image" src="../assets/jioMartBackgroung.png" alt="bg">
            <div class="container">
                <div class="heading">Welcome to JioMart Ads</div>
                <div class="ellipse"></div>
                <div class="content"> 
                    <div style="margin: 32px auto; color: #1D1D1D; width: 595px;">Thanks for being a valued seller on the JioMart platform. We acknowledge your acceptance of terms and conditions of JioMart Ads, and are excited to have you on board as a valued member of our community.</div>
                    <div style="margin: auto; color: #1D1D1D; width: 587px;">This is the beginning of a mutually beneficial journey, and we look forward to working closely with you. Your partnership with us opens up exciting opportunities, and we are committed to providing you with the support and resources you need to thrive.</div>
                    <!-- <div style="margin: auto; color: #1D1D1D; margin-bottom: 10px; width: 569px;"> The TnCs have been sent to your email address. You can view the updates in TnC here:</div>
                    <div class="link"> https:/m dolor sit amet, consectetur adipiscingelitsed do eiusmod tempor incididu</div> -->
                </div>
                <div class="btn" @click="logout">Logout</div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from './Header.vue';
import router from '../router';
import { API_AUTH_URL } from '../constants/index';
import { clearCookie, fetchWithAuth, getCookie, getQueryParam, validateSellerIdAndToken } from '../services/campaignService';

export default {
    name: 'StaticTnCPage',
    components: {
        Header
    },
    mounted(){
        let role = getCookie('role');
        if(role !== 'SELLER'){
            router.push('/unauthorized');
        }
        let loggedUserId = getCookie('userId');
        validateSellerIdAndToken(loggedUserId)
        .then(res => res.json())
        .then(data => {
            if (!!data?.token) {
                // authenticated valid case
            } else {
                router.push('/unauthorized');
            }
        })
    },
    methods: {
        async logout() {
            try {
                const requestOptions = {
                    method: 'POST',
                };
                const url = `${API_AUTH_URL}/v1/logout`;

                await fetchWithAuth(url, requestOptions)
                .then(res=>res.json())
                .then(data => {
                if (data?.code === 200) {
                    clearCookie('token');
                    clearCookie('sellerId');
                    clearCookie('role');
                    clearCookie('tncAcceptance');
                    clearCookie('userEmail');
                    clearCookie('userId');
                    clearCookie('ipAddress');
                    clearCookie('twoFactorRegistered');
                    this.$router.push('/');
                }else if(data?.message === 'Invalid token'){
                    router.push('/unauthorized');
                }
                }).catch(error => console.log(error));
            } catch (error) {
                console.log(error);
            }
        }
    }
    
}
</script>

<style scoped>
    @font-face {
        font-family: "Inter-Regular";
        src: url('../assets/fonts/Inter-Regular.ttf');
    }
    .ellipse{
        width: 9px;
        height: 9px;
        border-radius: 50%;
        background: #000093;
    }

    .tncPageContainer{
        background: #F8F8F8;
        height: 100vh;
    }

    .container{
        background: #FFFFFF;
        text-align: center;
        width: 731px;
        padding: 56px 0px 61px 0px;
        border-radius: 13px;
        padding: 56px 72px 66px;
        margin: 0 auto;
        position: absolute;
        top: 96px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .wrapper{
        position: relative;
        display: flex;
        justify-content: center;
    }

    .image{
        width: 100%;
    }

    .heading{
        font-size: 32px;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: -0.03em;
        margin-bottom: 36px;
    }

    .content{
        font-family: "Inter-Regular";

    }

    .link{
        font-family: "Inter-Regular";
        font-size: 22px;
        font-weight: 500;
        line-height: 31px;
        letter-spacing: 0em;
        text-align: center;
        width: 581px;
    }

    .btn{
        font-family: "Inter-Regular";
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
        letter-spacing: 0em;
        text-align: center;
        width: 214px;
        padding: 13px 0;
        border-radius: 4px;
        background: #2E31BE;
        margin: 87px auto 0;
        color: white;
        cursor: pointer;
    }
</style>
